import { removeOTPFocusEventListener, addOTPFocusEventListener } from "./app";

const TIMER_IN_SECS = 30;
const MAX_RESEND_ERROR =
  "You have reached the maximum attempts for requesting an OTP. Click <a href='/password-reset' class='alert-link'>here</a> to start again.";
const REQUEST_TOO_SOON_ERROR = "Please retry again in a few seconds.";
const MAX_SUBMIT_ERROR =
  "You have reached the maximum attempts for retries on the OTP. Click <a href='/password-reset' class='alert-link'>here</a> to start again.";
const DEFAULT_SUBMIT_ERROR =
  "An error occurred while submitting your OTP. Please try again.";
const PWD_RESET_EXPIRED_OTP_ERROR =
  "The OTP is expired. Click <a href='/password-reset' class='alert-link'>here</a> to start again.";
const INVALID_OTP_ERROR = "The OTP is incorrect. Please try again.";
const DEFAULT_RESEND_EMAIL_ERROR =
  "An error occurred while sending your verification link. Please try again.";
const DEFAULT_RESEND_MOBILE_ERROR =
  "An error occurred while sending your OTP. Please try again.";
const OTP_RESEND_SUCCESS = "OTP has been resent.";

const OTP_ERROR_CONTAINER_SELECTOR = ".otp-error-container";
const OTP_ERROR_MESSAGE_SELECTOR = ".otp-error-container .otp-error-message";
const SUCCESS_MESSAGE_SELECTOR = "#success-message";
const OTP_HIDDEN_INPUT = "#otp";
const RESEND_LINK_SELECTOR = ".resend-link";

export function showLoader() {
  $(RESEND_LINK_SELECTOR).addClass("loading");
}

export function hideLoader() {
  $(RESEND_LINK_SELECTOR).removeClass("loading");
}

export function showErrors(message, type = "mobile") {
  if (type === "mobile") {
    $(OTP_ERROR_MESSAGE_SELECTOR).html(message);
    $(OTP_ERROR_CONTAINER_SELECTOR).show();
  }
}

export function escapeText(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function disableForm(form) {
  form.addClass("submitting").find(":submit").attr("disabled", true);
  $(RESEND_LINK_SELECTOR).addClass("disabled");
}

export function preventIdSpam(e, submitForm) {
  disableForm(submitForm);
  $(".reset-btn").attr("disabled", true);
  $("#identityValue").attr("readonly", true);
}

export function resetTimer() {
  var ctr = TIMER_IN_SECS;

  $(RESEND_LINK_SELECTOR).css("display", "none");
  setTimerDisplay(ctr);
  $("#resend-timer").css("display", "block");

  var resetTimerId = setInterval(function () {
    ctr--;
    setTimerDisplay(ctr);
  }, 1000);

  setTimeout(function () {
    clearInterval(resetTimerId);
    $("#resend-timer").css("display", "none");
    $(RESEND_LINK_SELECTOR).css("display", "block");
  }, TIMER_IN_SECS * 1000);
}

export function setTimerDisplay(ctr) {
  const display = ctr < 10 ? `0${ctr}` : ctr;
  $("#resend-timer span").text(`00:${display}`);
}

export function showSuccess(type = "mobile") {
  if (type === "mobile") {
    $(SUCCESS_MESSAGE_SELECTOR).html(`<p>${OTP_RESEND_SUCCESS}</p>`).show();
  }
}

export function resetMessages() {
  $(OTP_ERROR_MESSAGE_SELECTOR)
    .html("")
    .removeClass("max-retries-error-message");
  $(OTP_ERROR_CONTAINER_SELECTOR).hide();
  $(SUCCESS_MESSAGE_SELECTOR).html("").hide();
}

export function enableForm($form) {
  $form.removeClass("submitting");
  $(RESEND_LINK_SELECTOR).removeClass("disabled");
  const otp = $(OTP_HIDDEN_INPUT);
  if (otp.val().length === 6 && !isNaN(otp.val())) {
    $("#continue").removeAttr("disabled");
  } else {
    $("#continue").attr("disabled", true);
  }
}

export function preventFormActions() {
  disableForm($("form"));
  $("form input").attr("disabled", true);
  $("#continue").attr("disabled", true);
  $(".resend-wrapper").html("");
}

export function resendPasswordOTP(errorMessage, type = "mobile") {
  resetMessages();

  $.ajax({
    url: "/password-reset/resend",
    type: "POST",
    data: {
      _csrf: $("#_csrf").val(),
    },
    dataType: "json",
    success: function (data) {
      if (!data.success) {
        if (data.code === "MaximumAttemptsReached") {
          showErrors(MAX_RESEND_ERROR, type);
          preventFormActions();
          return;
        }

        if (data.code === "ExpiredResetOtp") {
          showErrors(PWD_RESET_EXPIRED_OTP_ERROR, type);
          preventFormActions();
          return;
        }

        if (data.code === "RequestTooSoon") {
          errorMessage = REQUEST_TOO_SOON_ERROR;
        }

        showErrors(errorMessage, type);
      } else {
        showSuccess(type);
      }
    },

    error: function (_e) {
      showErrors(errorMessage, type);
    },

    complete: resetTimer,
  });
}

export function resendEmailLinkForPasswordReset(e) {
  e.preventDefault();
  resendPasswordOTP(DEFAULT_RESEND_EMAIL_ERROR, "email");
}

export function resendMobileOtpForPasswordReset(e) {
  e.preventDefault();
  resendPasswordOTP(DEFAULT_RESEND_MOBILE_ERROR, "mobile");
}

export function submitPasswordResetOtp(e, $passwordConfirmForm) {
  e.preventDefault();

  // Validation
  var otp = $(OTP_HIDDEN_INPUT).val().trim();
  if (!otp) {
    clearOTPInput();
  }

  // Submit
  disableForm($passwordConfirmForm);
  resetMessages();
  showLoader();

  $.ajax({
    url: "/password-reset/otp",
    type: "POST",
    data: {
      _csrf: $("#_csrf").val(),
      otp: $(OTP_HIDDEN_INPUT).val(),
    },
    dataType: "json",
    success: function (data) {
      // Redirect on success
      if (data.success) {
        window.location.replace("/password-reset/new");
        return;
      }

      // Show error message on error
      let errorMessage = DEFAULT_SUBMIT_ERROR;

      if (data.code === "MaximumAttemptsReached") {
        errorMessage = MAX_SUBMIT_ERROR;
        $(OTP_ERROR_MESSAGE_SELECTOR).addClass("max-retries-error-message");
        showErrors(errorMessage);
        $(".resend-wrapper").hide();
        return;
      } else if (data.code === "ExpiredResetOtp") {
        errorMessage = PWD_RESET_EXPIRED_OTP_ERROR;
      } else if (data.code === "InvalidResetOtp") {
        errorMessage = INVALID_OTP_ERROR;
      }

      clearOTPInput();
      showErrors(errorMessage);
      enableForm($passwordConfirmForm);
    },

    error: function (_e) {
      showErrors(DEFAULT_SUBMIT_ERROR);
      enableForm($passwordConfirmForm);
    },
    complete: hideLoader,
  });
}

export function clearOTPInput() {
  $(OTP_HIDDEN_INPUT).val("");
  $(".otp-field")
    .val("")
    .each((index, field) => {
      if (index !== 0) {
        addOTPFocusEventListener(field);
      } else {
        removeOTPFocusEventListener(field);
      }
    });
  $(".otp-fields .otp-field:first-child").focus();
}

function resendVerificationCode(verificationCodeForm) {
  const successDiv = $("#successMessage");

  const errorDiv = $(".resend-otp-error-container");
  const errorDivMessage = $(".resend-otp-error-container .otp-error-message");

  successDiv.html("");
  successDiv.hide();

  errorDivMessage.html("");
  errorDiv.hide();

  $(OTP_ERROR_MESSAGE_SELECTOR).html("");
  $(OTP_ERROR_CONTAINER_SELECTOR).hide();

  disableForm(verificationCodeForm);
  $.ajax({
    type: "POST",
    url: "/vcode/resend",
    data: {
      _csrf: $("#_csrf").val(),
    },
  })
    .done(function () {
      resetTimer();
      enableForm(verificationCodeForm);
    })
    .success(function (data) {
      if (data.successMessage) {
        successDiv.show();
        successDiv.html(`<p>${escapeText(data.successMessage)}</p>`);
      } else if (data.error && data.error === "Expired") {
        errorDiv.css("display", "flex");
        errorDivMessage.html(data.error_description);
      }
    })
    .fail(function (_error) {
      errorDiv.css("display", "flex");
      errorDivMessage.html("Unable to send verification code.");
    });
}

function resendLoginOTP() {
  const successDiv = $("#successMessage");
  const errorDiv = $("#errorMessage");

  successDiv.html("");
  successDiv.hide();
  errorDiv.html("");
  errorDiv.hide();

  $(OTP_ERROR_MESSAGE_SELECTOR).html("");
  $(OTP_ERROR_CONTAINER_SELECTOR).hide();

  var jqXhr = $.post(
    "otp/resend",
    { _csrf: $("#_csrf").val() },
    function (data) {
      if (data.successMessage) {
        successDiv.show();
        successDiv.html(`<p>${escapeText(data.successMessage)}</p>`);
      } else if (data.error && data.error === "ISS0009") {
        window.location.href = "login?otpExpired=true";
      }
    }
  );
  jqXhr.fail(function () {
    errorDiv.show();
    errorDiv.html("<p>Unable to send OTP.</p>");
  });
  jqXhr.complete(resetTimer);
}

$(function () {
  // Submit Identity
  const $passwordSubmitIdForm = $("#password-submit-identity-form");
  if ($passwordSubmitIdForm.length) {
    $passwordSubmitIdForm.on("submit", function (e) {
      preventIdSpam(e, $passwordSubmitIdForm);
    });
  }

  // Confirmation
  const $passwordConfirmForm = $("#password-confirm-form");
  if ($passwordConfirmForm.length) {
    resetTimer();
    $(".form-otp").on("submit", (e) => {
      submitPasswordResetOtp(e, $passwordConfirmForm);
    });

    // Resend actions
    $("#resend-mobile-otp").on("click", resendMobileOtpForPasswordReset);
    $("#resend-email-link").on("click", resendEmailLinkForPasswordReset);
  }

  // VCode OTP Form
  const $verificationCodeForm = $("#verification-otp-form");
  if ($verificationCodeForm.length) {
    $("#btn-resend-vcode").click(function () {
      resendVerificationCode($verificationCodeForm);
    });
  }

  const $loginOtpForm = $(".login-otp-form");
  if ($loginOtpForm.length) {
    $("#btn-resend-otp").click(resendLoginOTP);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get("otpExpired")) {
      disableForm($loginOtpForm);
    }
  }
});
